import { useState, useEffect } from 'react';

import axios from 'axios';

import routes from 'app/routes';

export default function useCareerPulseQuestions() {
  const [careerPulseQuestions, setCareerPulseQuestions] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.career_pulse_questions.index)
      .then((response) => {
        setCareerPulseQuestions(response.data.data);
      });
  }, []);

  return careerPulseQuestions;
}
